import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyAFClrMHL8Bf1rzYm3nKj6qNi2UKlzZOxM",
    authDomain: "cntt-k23m.firebaseapp.com",
    databaseURL: "https://cntt-k23m-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "cntt-k23m",
    storageBucket: "cntt-k23m.firebasestorage.app",
    messagingSenderId: "549319863600",
    appId: "1:549319863600:web:5f87975268b0cc7207acf5",
    measurementId: "G-KS5VQZ95PV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database
export const database = getDatabase(app);

export default app;
